// 通用图表点击事件混合
export default {
	data() {
		return {
			chartInstance: null,
			dataInstance: null,
		};
	},

	mounted() {
		// 等待DOM渲染完成后初始化图表
		this.$nextTick(() => {
			this.initChartWithClick();
		});
	},

	beforeDestroy() {
		if (this.chartInstance) {
			this.chartInstance.dispose();
		}
	},

	methods: {
		initChartWithClick() {
			// 这个方法需要被子组件重写
		},

		// 设置图表点击事件
		setupChartClick(data, type) {
			if (!data) return;
			if (type == 'echarts') {
				console.log(data, '图表的点击事件')
				this.chartInstance = data;
				this.chartInstance.on('click', this.handleChartClick);
			} else if (type == 'shuju') {
				console.log(data, '数据概览的点击事件')
				this.handleDataClick(data)
				// this.dataInstance = data;
				// this.dataInstance.on('click', this.handleDataClick);
			} else if (type == 'list') {
				console.log(data, '列表的点击事件')
				this.handleListClick(data)
				// this.dataInstance = data;
				// this.dataInstance.on('click', this.handleDataClick);
			}

		},
		// 通用点击图表事件处理方法
		handleChartClick(params) {
			// 处理 yAxis/xAxis 标签点击（triggerEvent:true 时 params.data 为空，name 在 params.value）
			let dataObj;
			if (params.componentType === 'yAxis' || params.componentType === 'xAxis') {
				dataObj = { name: params.value };
			} else {
				dataObj = params.data || params;
			}
			// 触发自定义事件，传递点击的数据给父组件
			this.$emit('chart-click', {
				chartName: this.chartName || this.title || '图表',
				data: dataObj,
				seriesName: params.seriesName || (params.data && params.data.name),
				componentName: this.$options.name,
				chartType: this.chartType || 'unknown'
			});
		},
		// 通用点击数据概览事件处理方法
		handleDataClick(params) {
			// 触发自定义事件，传递点击的数据给父组件
			console.log(params, 'params点击收货')
			this.$emit('data-click', {
				chartName: params.title||this.chartName || this.title || '图表',
				title: params.title || "",
				num: params.num || "",
				danwei: params.danwei || "",
			});
		},
		// 通用点击滚动列表事件处理方法
		handleListClick(params) {
			console.log('点击资产:', params);

			// 触发自定义事件，传递统一的资产数据
			this.$emit('list-click', {
				// 必需字段
				id: params.id,
				assetCode: params.assetCode,
				assetName: params.assetName,
				assetType: params.assetType,
				manager: params.manager,
				createTime: params.createTime,

				// 可选字段
				status: params.status,
				amount: params.amount,
				address: params.address,
				description: params.description,
				fadingdaibiao:params.fadingdaibiao,
				assetDetailName: params.assetDetailName,
				dongshi: params.dongshi,
				jingli: params.jingli,
				videoUrlStr: params.videoUrlStr,
				videoUrls: params.videoUrls,

			});
		},



		handleResize() {
			if (this.chartInstance) {
				this.chartInstance.resize();
			}
		}
	}
};